import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AssignmentInstructions, Bricks, Button, FavoritePickerPhoto, SidebarContent } from 'components';

import { getChildBirthday } from 'redux/selectors/orders';
import { getFilteredForPage } from 'redux/selectors/photos';
import { getAvailableMoments, getSpreadInfo } from 'redux/selectors/books';
import { openPicker, setDragging } from 'redux/reducers/app';

import styles from './styles.scss';

const favoritesForPage = getFilteredForPage('favorites');

@connect(
  (state, props) => ({
    orderId: state.getIn(['app', 'activeOrderId']),
    appWidth: state.getIn(['app', 'dimensions', 'width']),
    favorites: favoritesForPage(state),
    availableMoments: getAvailableMoments(state),
    activeSpreadIds: state.getIn(['app', 'activeSpreadIds']),
    isMonthSpread: getSpreadInfo(state).get('isMonthSpread', false),
    childBirthday: getChildBirthday(state),
  }),
  {
    setDragging,
    openPicker,
  }
)
export default class Picker extends React.PureComponent {
  static contextTypes = {
    bookId: PropTypes.number,
  };

  render() {
    const {
      orderId,
      availableMoments,
      setDragging,
      favorites,
      childBirthday,
      appWidth,
      activeSpreadIds,
      isMonthSpread,
    } = this.props;
    const { bookId } = this.context;
    const photoMoments = availableMoments.filter(moment => moment.get('type') === 'photo');
    const hasPhotoMoments = photoMoments.count() > 0;
    const hasSelectedPhoto = favorites.count() > 0;
    const spreadId = activeSpreadIds.get(orderId);

    let content = null;

    // If there should be a default message for spreads without photos, enter it below.
    let actions = '';

    if (hasPhotoMoments) {
      const favoritesPhotos = favorites
        .map(photo => (
          <FavoritePickerPhoto
            key={photo.get('simpleId')}
            photo={photo}
            setDragging={setDragging}
            isMonthSpread={isMonthSpread}
            childBirthday={childBirthday}
            className={styles.photo}
          />
        ))
        .toArray();

      const ctaText = hasSelectedPhoto ? kroostApp.strings.photosChooseMore : kroostApp.strings.photosChoose;
      actions = [
        <div className={styles.actionContainer} key="choose">
          <Button cta={!hasSelectedPhoto} secondary={true} to={`/${bookId}/${orderId}/assignment`}>
            {ctaText}
          </Button>
        </div>,
      ];

      content =
        favoritesPhotos.length === 0 ? (
          <div>
            <AssignmentInstructions />
            <div className={styles.empty} />
          </div>
        ) : (
          <div>
            <AssignmentInstructions closed={true} />
            <div className={styles.brickContainer}>
              <Bricks key={appWidth} columns={2} photos={favoritesPhotos} />
            </div>
          </div>
        );
    } else {
      content = <AssignmentInstructions />;
    }

    //console.log(spreadId);
    return (
      <SidebarContent key={spreadId} actions={actions} innerClassName={styles.removeInnerPadding}>
        {content}
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/favorite-picker/index.js